
<template>
  <div class="img-swiper">
    <span
      class="cur-index"
      v-if="showIndex"
    >
      <span class="top">{{ status.curIndex + 1 }}</span> <i>/</i>
      <span class="bottom">{{ items.length }}</span></span>
    <el-carousel
      v-if="items.length"
      ref="swiperRef"
      :height="height + 'px'"
      :autoplay="false"
      :arrow="items.length == 1 ? 'never' : 'always'"
      @change="handleChangeSwiper"
    >
      <el-carousel-item
        v-for="(item, i) in items"
        :key="i"
        indicator-position="none"
      >
        <div
          class="img-wraps"
          :style="{ height: height + 'px' }"
        >
          <div class="img-item">
            <div class="preview-detail">
              <img
                @click.stop="handleViewBigPic(i)"
                v-if="i == status.curIndex"
                class="img preview-img"
                :src="item[displayKey]"
              />
            </div>
            <slot :item="item"></slot>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div
      class="img-swiper-preview"
      ref="swiperPreviewRef"
    >
      <div
        class="item"
        v-for="(item, i) in items"
        :key="i"
        @click="handleChange(i)"
        :ref="(el) => (domRef[i] = el)"
      >
        <div
          class="swiper-img"
          :class="{ active: status.curIndex == i }"
        >
          <div class="swiper-img-wrap">
            <img
              :src="item[thumbnailKey]"
              alt=""
            />
          </div>
        </div>
        <slot :index="i"></slot>
      </div>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :hide-on-click-modal="true"
      :url-list="srcList"
      :initial-index="previewIndex"
      @close="closeViewer"
    />
  </div>
</template>
<script>
import { ElImageViewer } from "element-plus";
import { reactive, toRefs, ref } from "vue";
export default {
  components: {
    ElImageViewer,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    thumbnailKey: {
      //缩略图取用字段
      type: String,
      default: "smallImagePath",
    },
    displayKey: {
      //轮播展示取用字段
      type: String,
      default: "middleImagePath",
    },
    bigDisplayKey: {
      type: String,
      default: "originalFilePath",
    },
    height: {
      type: Number,
      default: 200,
    },
    // 显示前面的图片索引
    showIndex: {
      type: Boolean,
      default: false,
    },
    // 显示预览大图按钮
    showBigPicBtn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const swiperRef = ref(null),
      swiperPreviewRef = ref(null),
      domRef = ref([]);
    const state = reactive({
      status: {
        curIndex: 0,
      },
      showViewer: false,
      previewIndex: 0,
      srcList: props.items.map((n) => {
        return n[props.bigDisplayKey];
      }),
    });
    /**
     * @description: 点击底下缩略图切换
     * @param {*} index
     * @return {*}
     */
    function handleChange(index) {
      swiperRef.value?.setActiveItem(Number(index));
      state.status.curIndex = index;
      state.status.isClick = true;
      emit("change", { item: props.items[index], index });
    }
    /**
     * @description: 切换轮播图
     * @param {*} index
     * @return {*}
     */
    function handleChangeSwiper(index) {
      if (state.status.isClick) {
        state.status.isClick = false;
        return;
      }
      let left = domRef.value[index]?.offsetLeft,
        originLeft = swiperPreviewRef.value.offsetLeft;
      swiperPreviewRef.value.scrollLeft = left - originLeft;

      state.status.curIndex = index;

      emit("change", { item: props.items[index], index });
    }

    // 关闭大图预览
    const closeViewer = () => {
      state.showViewer = false;
    };
    // 预览大图
    const handleViewBigPic = (index) => {
      if (!props.showBigPicBtn) return;
      console.log("index", index);
      state.previewIndex = index;
      state.showViewer = true;
    };
    return {
      swiperRef,
      swiperPreviewRef,
      domRef,
      ...toRefs(state),
      handleChange,
      handleChangeSwiper,
      closeViewer,
      handleViewBigPic,
    };
  },
};
</script>
<style lang="less" scoped>
:deep(.el-carousel) {
  .el-carousel__indicators {
    display: none;
  }
  .el-carousel__container {
    display: flex;
    align-items: center;
  }
  .el-carousel__arrow--left,
  .el-carousel__arrow--right {
    display: block !important;
  }
}
.img-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .tm-icon-fangdatupian {
    position: absolute;
    font-size: 24px;
    color: #000;
    top: 0;
    right: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    border-radius: 4px;
  }
  .preview-detail {
    position: relative;
    height: 100%;
  }
}
.img-swiper {
  position: relative;
  .cur-index {
    width: 66px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 18px;
    right: 20px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    background: #000000;
    border-radius: 2px;
    opacity: 0.6;
    z-index: 2;
    i {
      padding: 0 5px;
    }
  }
}
.img-swiper-preview {
  margin-top: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: calc(100% - 20px);
  overflow-x: auto;
  overflow-y: hidden;
  .item {
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 10px;
    .swiper-img {
      display: inline-block;
      cursor: pointer;
      &.active {
        img {
          border-color: @themePrimaryColor;
        }
      }
      .swiper-img-wrap {
        height: 70px;
        line-height: 70px;
        font-size: 0;
      }
    }
    &:last-child {
      margin-right: 0;
    }
    img {
      display: inline-block;
      vertical-align: middle;
      width: auto;
      max-height: 64px;
      background: #fff;
      border: 3px solid transparent;
      border-radius: 3px;
    }
  }
}
.img-wraps {
  position: relative;
  :deep(.el-button) {
    position: absolute;
    top: 0;
    display: none;
    z-index: 2;
  }
  &:hover {
    :deep(.el-button) {
      display: block;
    }
  }
}
:deep(.el-image-viewer__mask) {
  opacity: 0.9;
}
.preview-img {
  &:hover {
    cursor: zoom-in;
  }
}
</style>
